  <c-header class="align-content-end justify-content-end text-end shadow-sm">
    <ul class="nav navbar-nav ml-auto mr-3 text-white">
      <li cDropdown class="nav-item">
        <a cDropdownToggle class="nav-link">
          {{ userName$ | async }}
        </a>
        <div cDropdownMenu class="dropdown-menu dropdown-menu-end">
          <button cDropdownItem (click)="logout()">Logout</button>
        </div>
      </li>
    </ul>
  </c-header>
  <ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
  <div class="app-body">
    <c-sidebar
      [visible]="sidebarShow"
      #appSidebar
      id="appSideBar"
      class="sidebar sidebar-show"
      (visibleChange)="toggleMinimize($event)"
    >
      <c-sidebar-brand
        class="text-center p-2"
        [routerLink]="'/'"
        [brandFull]="{src: 'assets/logo.png', width: 80, height: 37, alt: 'Fitrite Logo'}"
        [brandNarrow]="{src: 'assets/logo.png', width: 80, height: 37, alt: 'Fitrite Logo'}"
      ></c-sidebar-brand>

      <c-sidebar-nav [navItems]="navItems" class="sidebar-nav"></c-sidebar-nav>
    </c-sidebar>
    <div class="wrapper d-flex flex-column min-vh-100">
      <router-outlet></router-outlet>
    </div>
  </div>
  <c-footer>
    <span class="ml-auto">Powered by <a href="https://www.fitrite.info">Fitrite</a></span>
  </c-footer>
